import 'babel-polyfill'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import ELEMENT, { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/css/global.less'

import axios from 'axios'
import qs from 'qs'
// import '@/utils/quillImg.js'
// 自定义全局指令
import '@/directive/index.js'
// 挂载到$message上
import VueResource from 'vue-resource'
import FormRules from '@/assets/js/FormRules.js'
// select
import wl from 'wl-vue-select'
import 'wl-vue-select/lib/wl-vue-select.css'
// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
import config from '@/config'
import reg from '@/reg'
// moment
import moment from 'moment' // 需要汉化
import { checkAwsSdk } from '@/utils/uploadWebImg.js'
import convertCurrency from '@/utils/convertCurrency.js'
Vue.prototype.$message = Message
// let elementUI = require('element-ui')
Vue.prototype.$checkAwsSdk = checkAwsSdk
Vue.prototype.$convertCurrency = convertCurrency // 数字转大写
Vue.prototype.$moment = moment // 赋值使用
moment.locale('zh-cn')
Vue.use(VueResource)
Vue.use(VueQuillEditor)
Vue.use(wl)
Vue.use(ELEMENT)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$FormRules = FormRules
Vue.prototype.$qs = qs
Vue.prototype.$config = config
Vue.prototype.$reg = reg

// 回到页面顶部
router.afterEach((to, from, next) => {
  if (next) {
    return next
  } else {
    return { x: 0, y: 0 }
  }
  // window.scrollTo(0, 0)
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
